import shipped from './deviceDetector.json';

/*
 * What the app knows of the device detector: deviceDetector.json, written by
 * `python -m backend.ai.device_detector export`. The hash comes with the app and the model doesn't, so a model file
 * alone can't change what runs. Today it holds no model, and then nothing here fetches anything.
 *
 * `mayGate` is the twin of backend/ai/device_boxes.py's `may_gate` (detect_cases.json): the sharpness-only gate gives
 * way only to a detector measured on people's boxes and on a real phone inside the budget. A trial never does.
 */
export const BUDGET_MS = 200;
export const FORMAT = 1;

export function usableManifest(manifest = shipped) {
  const { format, model, input, strides, classes } = manifest || {};
  return !!(format === FORMAT && model?.url && model?.sha256 && input?.size && strides?.length && classes?.length);
}

export function mayGate(manifest = shipped) {
  if (!manifest || manifest.trial || !manifest.model || !manifest.training) return false;
  const { test_set: testSet, phones } = manifest;
  if (testSet?.precision === null || testSet?.precision === undefined
    || testSet?.recall === null || testSet?.recall === undefined) return false;
  return !!phones?.length && phones.every(p => typeof p.ms_p95 === 'number' && p.ms_p95 <= BUDGET_MS);
}

export default shipped;
